import { currentEnvironment } from "@porsche-customer/slfinrtl-environment"
import type { RedirectUrl } from "@slfinrtl/ui-bff-routes"
import { getDealershipRedirectRoute } from "@slfinrtl/ui-bff-routes"
import type { CreateAxiosDefaults } from "axios"
import axios from "axios"
import { useCallback } from "react"
import { urlMap } from "src/common/getAxiosInstance/urlMap"

export const useDealershipRedirect = (
	getAuthorizationHeader: () => Promise<{
		Authorization: string
	}>,
) => {
	return useCallback(async () => {
		const { Authorization } = await getAuthorizationHeader()
		const axiosInstance = getAxiosInstance({ Authorization })
		const url = getDealershipRedirectRoute.buildUrl({})
		const response = await axiosInstance.get<RedirectUrl | undefined>(url)
		return response?.data
	}, [getAuthorizationHeader])
}

interface AxiosParams {
	Authorization: string
}

const getAxiosInstance = ({ Authorization }: AxiosParams) => {
	const environment = currentEnvironment()
	const createAxiosDefaults: CreateAxiosDefaults<AxiosParams> = {
		baseURL: urlMap[environment ?? "local"],
		headers: {
			accept: "application/json",
			Authorization,
			"Content-Type": "application/json",
		},
	}

	return axios.create(createAxiosDefaults)
}
